export default {
    backgroundColor: '#cee4e5',
    // color: 'blue',
};
